import MeasureSVG from './Measures.svg?raw'
const style = String.raw`
<style>
dialog {
	--pixelPitch: 1;

	position: fixed;
	bottom: 5vh;
	left: 5vw;
	display: flex;
	z-index: 10000;
	width: 90vw;
	
	margin: 0;
	
	border: none;
	border-radius: 20px;
	box-shadow: 5px 5px 100px rgba(0,0,0, 0.25);	
	gap: 20px;
}

#card, svg {
	position: fixed;
	top:50%; 
	left:50%;
	transform: translate(-50%, -50%);

}
@media (orientation: portrait) {
	#card, svg {
		transform: translate(-50%, -50%) rotate(90deg);
	}	
}


svg {
	/*110 x 20*/
	aspect-ratio: 110 / 82;
	width: calc(110px / var(--pixelPitch));
	height: auto;
}

#numeric {
	position: absolute;
	bottom: 60px;
	width: 100px;
	padding: 10px 0;
	transform: translateX(-50%);
	font-size: 30px;
	font-family: Bjarkesvej, system-ui;
	font-feature-settings: 'tnum';
	text-align: center;
	border: none;
	
	border-radius: 15px;
	box-shadow: 1px 1px 10px rgba(0,0,0, 0.25);
}

#slider {
	appearance: none;
	width: 100%;
	height: 15px;
	border-radius: 5px;  
	background: #d3d3d3;
	outline: none;
	opacity: 0.7;
	-webkit-transition: .2s;
	transition: opacity .2s;
	place-self: end;	
}

#slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 25px;
	height: 25px;
	border-radius: 50%; 
	background: #5a6c85;
	cursor: pointer;
}

#slider::-moz-range-thumb {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #5a6c85;
	cursor: pointer;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type=number]{
	-moz-appearance: textfield;
}

#slider, button {
	place-self: center;
	margin: 10px;
}

button {
	font-family: Bjarkesvej, system-ui;
	background: #FBFBFB;
	border: 1px solid #474747;
	border-radius: 12px;
	padding: 8px 16px;
	font-size: 18px;	
	color: #333;

	border: none;
	
	border-radius: 15px;
	box-shadow: 1px 1px 10px rgba(0,0,0, 0.25);
	&:active {
		transform: scale(0.9);
	}
}
</style>`

const ruler = String.raw`<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="110mm" height="20mm" viewBox="0 0 311.811 56.6929">
  <defs>
    <style>
      .db {
        fill: none;
        stroke: #000;
        stroke-linecap: round;
        stroke-width: .8px;
      }
    </style>
  </defs>
  <g id="a" data-name="NUMBERS">
    <path id="b" data-name="path12958-2-8" class="db" d="M14.1732,2.4571V30.8035"/>
    <path id="c" data-name="path12958-2-8-71" class="db" d="M42.5197,2.4571V30.8035"/>
    <path id="d" data-name="path12958-2-8-2" class="db" d="M99.2126,2.4571V30.8035"/>
    <path id="e" data-name="path12958-2-8-43" class="db" d="M70.8661,2.4571V30.8035"/>
    <path id="f" data-name="path12958-2-8-79" class="db" d="M184.252,2.4571V30.8035"/>
    <path id="g" data-name="path12958-2-8-24" class="db" d="M127.5591,2.4571V30.8035"/>
    <path id="h" data-name="path12958-2-8-6" class="db" d="M155.9055,2.4571V30.8035"/>
    <path id="i" data-name="path12958-2-8-84" class="db" d="M212.5984,2.4571V30.8035"/>
    <path id="j" data-name="path12958-2-8-72" class="db" d="M240.9449,2.4571V30.8035"/>
    <path id="k" data-name="path12958-2-8-46" class="db" d="M297.6378,2.4571V30.8035"/>
    <path id="l" data-name="path12958-2-8-60" class="db" d="M269.2913,2.4571V30.8035"/>
  </g>
  <g id="m" data-name="CM">
    <g>
      <path d="M293.1553,40.3213h-1.8477l.8857-1.5088h2.5742v10.6855h-1.6123v-9.1768Z"/>
      <path d="M297.8135,44.0859c0-1.7021,.3965-3.0605,1.1895-4.0762,.7109-.918,1.5713-1.377,2.582-1.377,1.0098,0,1.8701,.459,2.5811,1.377,.7939,1.0156,1.1904,2.3975,1.1904,4.1455,0,1.7441-.3965,3.124-1.1904,4.1387-.7109,.918-1.5684,1.377-2.5742,1.377s-1.8691-.459-2.5889-1.377c-.793-1.0146-1.1895-2.418-1.1895-4.208Zm1.584,.0068c0,1.1865,.2061,2.1709,.6162,2.9551,.4111,.7705,.9346,1.1562,1.5713,1.1562,.6318,0,1.1553-.3857,1.5703-1.1562,.416-.7656,.623-1.7324,.623-2.8994s-.207-2.1357-.623-2.9062c-.415-.7666-.9385-1.1494-1.5703-1.1494-.6279,0-1.1494,.3828-1.5645,1.1494-.415,.7607-.623,1.7109-.623,2.8506Z"/>
    </g>
    <path d="M10.4023,44.0859c0-1.7021,.397-3.0605,1.1904-4.0762,.7104-.918,1.5708-1.377,2.5811-1.377s1.8711,.459,2.5815,1.377c.7935,1.0156,1.1904,2.3975,1.1904,4.1455,0,1.7441-.397,3.124-1.1904,4.1387-.7104,.918-1.5688,1.377-2.5742,1.377s-1.8687-.459-2.5884-1.377c-.7935-1.0146-1.1904-2.418-1.1904-4.208Zm1.585,.0068c0,1.1865,.2051,2.1709,.6157,2.9551,.4106,.7705,.9346,1.1562,1.5708,1.1562,.6323,0,1.1558-.3857,1.5713-1.1562,.415-.7656,.6226-1.7324,.6226-2.8994s-.2075-2.1357-.6226-2.9062c-.4155-.7666-.939-1.1494-1.5713-1.1494-.6274,0-1.1484,.3828-1.564,1.1494-.415,.7607-.6226,1.7109-.6226,2.8506Z"/>
    <path d="M42.7065,40.3174h-1.8477l.8857-1.5088h2.5747v10.6855h-1.6128v-9.1768Z"/>
    <path d="M70.6143,48.0684h3.979v1.5156h-7.1763l3.7095-4.4912c.3643-.4473,.6699-.835,.917-1.1631,.2466-.3271,.4346-.6016,.564-.8232,.2627-.4336,.3945-.8232,.3945-1.1699,0-.498-.1758-.915-.5264-1.252s-.7842-.5059-1.3008-.5059c-1.0796,0-1.6978,.6396-1.855,1.917h-1.6055c.2583-2.251,1.3955-3.377,3.4121-3.377,.9731,0,1.79,.3096,2.4497,.9277,.6646,.6182,.9966,1.3838,.9966,2.2969,0,.582-.1548,1.1514-.4639,1.71-.1567,.29-.3862,.6357-.6885,1.0342-.3022,.3994-.6841,.8711-1.1455,1.415l-1.6606,1.9658Z"/>
    <path d="M99.0825,44.54v-1.377c.6826,0,1.1416-.0762,1.377-.2285,.4199-.2676,.6299-.6973,.6299-1.2871,0-.457-.1523-.8281-.4565-1.1143-.3003-.291-.6899-.4365-1.1699-.4365-.4473,0-.7935,.1084-1.0381,.3252-.2354,.2217-.4106,.5957-.5259,1.1211h-1.6055c.166-1.0049,.5073-1.7422,1.0244-2.2109,.5166-.4678,1.2388-.7021,2.166-.7021,.9365,0,1.7002,.2764,2.2905,.8301,.5908,.5498,.8857,1.2578,.8857,2.125,0,.9785-.3872,1.7393-1.1626,2.2832,.8857,.5215,1.3291,1.3682,1.3291,2.54,0,.96-.3232,1.7441-.9692,2.3535-.646,.6084-1.4741,.9131-2.4844,.9131-1.2871,0-2.2422-.4727-2.8652-1.4189-.2583-.3965-.4219-.9453-.4912-1.6465h1.5571c.083,.5166,.2847,.9121,.6055,1.1865s.7393,.4121,1.2563,.4121c.521,0,.9526-.1729,1.2939-.5195,.3413-.3545,.5122-.8047,.5122-1.3496,0-.7197-.2563-1.2314-.7681-1.5361-.3003-.1748-.7637-.2627-1.3911-.2627Z"/>
    <path d="M130.6992,46.9102h1.1348v1.4668h-1.1348v1.5156h-1.6123v-1.5156h-5.2461l6.8584-9.9658v8.499Zm-1.6123,0v-3.5781l-2.4639,3.5781h2.4639Z"/>
    <path d="M185.8584,38.5371l1.1826,.8857-2.5537,3.4736c.1387-.0186,.2568-.0322,.3535-.041,.0967-.0098,.1729-.0146,.2285-.0146,.8672,0,1.6172,.333,2.249,.9971,.627,.6553,.9414,1.4443,.9414,2.3672,0,.9775-.3506,1.8174-1.0518,2.5186-.6973,.6973-1.5342,1.0449-2.5127,1.0449-.9688,0-1.8174-.3438-2.5469-1.0312-.7148-.6875-1.0723-1.502-1.0723-2.4424,0-.8447,.3477-1.7393,1.0449-2.6855l3.7373-5.0723Zm.8301,7.7715c0-.5674-.1963-1.0479-.5879-1.4395-.3975-.3965-.875-.5957-1.4326-.5957-.5635,0-1.041,.1963-1.4326,.5889-.3926,.3916-.5889,.8672-.5889,1.4258,0,.5576,.1963,1.0332,.5889,1.4248,.3916,.3926,.8721,.5889,1.4395,.5889,.5537,0,1.0264-.1963,1.4189-.5889,.3965-.3965,.5947-.8643,.5947-1.4043Z"/>
    <path d="M214.4023,40.1357h-5.2734v-1.5088h7.9658l-6.7402,11.0527-1.2812-.8105,5.3291-8.7334Z"/>
    <path d="M239.5898,43.9404c-.7842-.5527-1.1768-1.3076-1.1768-2.2627,0-.8672,.2979-1.5918,.8926-2.1729,.5996-.5811,1.3447-.8721,2.2354-.8721,.8857,0,1.624,.291,2.2148,.8721,.5908,.5771,.8857,1.3037,.8857,2.1797,0,.918-.3896,1.668-1.1699,2.249,.4297,.2314,.7666,.5674,1.0107,1.0107,.249,.4434,.374,.9414,.374,1.4951,0,.9453-.3096,1.7207-.9277,2.3252s-1.4092,.9062-2.374,.9062c-.9873,0-1.8018-.3047-2.4424-.9131-.6465-.6094-.9688-1.375-.9688-2.2979,0-1.1992,.4814-2.0391,1.4463-2.5195Zm.1387,2.4639c0,.4941,.1699,.918,.5117,1.2734,.3457,.3506,.7656,.5264,1.2598,.5264,.4883,0,.9062-.1729,1.252-.5195,.3467-.3506,.5195-.7705,.5195-1.2588,0-.4941-.1729-.9141-.5195-1.2598-.3457-.3467-.7637-.5195-1.252-.5195-.4844,0-.9023,.1729-1.2529,.5195-.3457,.3457-.5186,.7588-.5186,1.2383Zm.2002-4.7334c0,.457,.1543,.8398,.4639,1.1484,.3135,.3145,.6924,.4707,1.1348,.4707,.4385,0,.8145-.1562,1.1279-.4707,.3135-.3135,.4707-.6895,.4707-1.1279,0-.4375-.1572-.8135-.4707-1.1279-.3135-.3135-.6895-.4707-1.1279-.4707s-.8145,.1572-1.1279,.4707c-.3135,.3145-.4707,.6826-.4707,1.1074Z"/>
    <path d="M268.7275,49.7695l-1.1836-.8789,2.5537-3.4814c-.1387,.0186-.2559,.0322-.3525,.042-.0977,.0088-.1758,.0137-.2354,.0137-.8633,0-1.6104-.3301-2.2422-.9902-.6279-.6543-.9414-1.4434-.9414-2.3662,0-.9834,.3477-1.8223,1.0449-2.5195,.7012-.7012,1.541-1.0518,2.5186-1.0518,.9736,0,1.8203,.3457,2.54,1.0381,.7197,.6875,1.0801,1.499,1.0801,2.4355,0,.8311-.3506,1.7285-1.0518,2.6924l-3.7305,5.0664Zm-.8311-7.7793c0,.5771,.1963,1.0615,.5889,1.4531,.3965,.3975,.874,.5957,1.4326,.5957,.5576,0,1.0332-.1963,1.4258-.5879,.3965-.3975,.5947-.875,.5947-1.4326,0-.5586-.1982-1.0361-.5947-1.4326-.3926-.3926-.8701-.5889-1.4326-.5889-.5537,0-1.0273,.1963-1.4189,.5889-.3965,.3965-.5957,.8643-.5957,1.4043Z"/>
    <path d="M159.7656,40.2314h-3.2944l-.5259,1.7715c.0786-.0088,.1533-.0156,.2251-.0205,.0713-.0049,.1372-.0068,.1973-.0068,1.0386,0,1.8882,.3506,2.5542,1.0518,.668,.6973,1.002,1.5898,1.002,2.6787,0,1.125-.377,2.0527-1.1348,2.7812-.7559,.7295-1.709,1.0938-2.8574,1.0938-1.4165,0-2.5332-.6641-3.3496-1.9932l1.2178-1.0312c.3369,.5723,.6758,.9766,1.0176,1.2109,.3413,.2314,.7588,.3467,1.2524,.3467,.646,0,1.188-.2266,1.6255-.6787,.4395-.4658,.6582-1.0312,.6582-1.6953,0-.6826-.2168-1.2412-.6504-1.6748-.4336-.4473-.9756-.6709-1.6265-.6709-.7241,0-1.3496,.3154-1.8755,.9482h-.5327l1.6816-5.6201h4.4155v1.5088Z"/>
  </g>
  <g id="n" data-name="CM/2">
    <path id="o" data-name="path12958-2-8-7-8" class="db" d="M28.3465,2.4571V23.7169"/>
    <path id="p" data-name="path12958-2-8-7-8-6" class="db" d="M56.6929,2.4571V23.717"/>
    <path id="q" data-name="path12958-2-8-7-8-1" class="db" d="M113.3858,2.4571V23.717"/>
    <path id="r" data-name="path12958-2-8-7-8-11" class="db" d="M85.0394,2.4571V23.717"/>
    <path id="s" data-name="path12958-2-8-7-8-65" class="db" d="M198.4252,2.4571V23.717"/>
    <path id="t" data-name="path12958-2-8-7-8-61" class="db" d="M141.7323,2.4571V23.717"/>
    <path id="u" data-name="path12958-2-8-7-8-7" class="db" d="M170.0787,2.4571V23.717"/>
    <path id="v" data-name="path12958-2-8-7-8-15" class="db" d="M226.7717,2.4571V23.717"/>
    <path id="w" data-name="path12958-2-8-7-8-5" class="db" d="M255.1181,2.4571V23.717"/>
    <path id="x" data-name="path12958-2-8-7-8-4" class="db" d="M283.4646,2.4571V23.717"/>
  </g>
  <g id="y" data-name="MM">
    <path id="z" data-name="path12958-2-8-7" class="db" d="M17.0079,2.4571v14.1732"/>
    <path id="aa" data-name="path12958-2-8-0" class="db" d="M19.8425,2.4571v14.1732"/>
    <path id="ab" data-name="path12958-2-8-4" class="db" d="M22.6772,2.4571v14.1732"/>
    <path id="ac" data-name="path12958-2-8-8" class="db" d="M25.5118,2.4571v14.1732"/>
    <path id="ad" data-name="path12958-2-8-0-2" class="db" d="M31.1811,2.4571v14.1732"/>
    <path id="ae" data-name="path12958-2-8-4-4" class="db" d="M34.0157,2.4571v14.1732"/>
    <path id="af" data-name="path12958-2-8-4-4-5" class="db" d="M36.8504,2.4571v14.1732"/>
    <path id="ag" data-name="path12958-2-8-4-4-1" class="db" d="M39.685,2.4571v14.1732"/>
    <path id="ah" data-name="path12958-2-8-7-1" class="db" d="M45.3543,2.4571v14.1732"/>
    <path id="ai" data-name="path12958-2-8-0-5" class="db" d="M48.189,2.4571v14.1732"/>
    <path id="aj" data-name="path12958-2-8-4-2" class="db" d="M51.0236,2.4571v14.1732"/>
    <path id="ak" data-name="path12958-2-8-8-7" class="db" d="M53.8583,2.4571v14.1732"/>
    <path id="al" data-name="path12958-2-8-0-2-1" class="db" d="M59.5276,2.4571v14.1732"/>
    <path id="am" data-name="path12958-2-8-4-4-4" class="db" d="M62.3622,2.4571v14.1732"/>
    <path id="an" data-name="path12958-2-8-4-4-5-2" class="db" d="M65.1968,2.4571v14.1732"/>
    <path id="ao" data-name="path12958-2-8-4-4-1-3" class="db" d="M68.0315,2.4571v14.1732"/>
    <path id="ap" data-name="path12958-2-8-7-16" class="db" d="M102.0472,2.4571v14.1732"/>
    <path id="aq" data-name="path12958-2-8-0-8" class="db" d="M104.8819,2.4571v14.1732"/>
    <path id="ar" data-name="path12958-2-8-4-5" class="db" d="M107.7165,2.4571v14.1732"/>
    <path id="as" data-name="path12958-2-8-8-76" class="db" d="M110.5512,2.4571v14.1732"/>
    <path id="at" data-name="path12958-2-8-0-2-8" class="db" d="M116.2205,2.4571v14.1732"/>
    <path id="au" data-name="path12958-2-8-4-4-9" class="db" d="M119.0551,2.4571v14.1732"/>
    <path id="av" data-name="path12958-2-8-4-4-5-27" class="db" d="M121.8898,2.4571v14.1732"/>
    <path id="aw" data-name="path12958-2-8-4-4-1-9" class="db" d="M124.7244,2.4571v14.1732"/>
    <path id="ax" data-name="path12958-2-8-7-12" class="db" d="M73.7008,2.4571v14.1732"/>
    <path id="ay" data-name="path12958-2-8-0-3" class="db" d="M76.5354,2.4571v14.1732"/>
    <path id="az" data-name="path12958-2-8-4-3" class="db" d="M79.3701,2.4571v14.1732"/>
    <path id="ba" data-name="path12958-2-8-8-4" class="db" d="M82.2047,2.4571v14.1732"/>
    <path id="bb" data-name="path12958-2-8-0-2-3" class="db" d="M87.874,2.4571v14.1732"/>
    <path id="bc" data-name="path12958-2-8-4-4-8" class="db" d="M90.7087,2.4571v14.1732"/>
    <path id="bd" data-name="path12958-2-8-4-4-5-7" class="db" d="M93.5433,2.4571v14.1732"/>
    <path id="be" data-name="path12958-2-8-4-4-1-4" class="db" d="M96.378,2.4571v14.1732"/>
    <path id="bf" data-name="path12958-2-8-7-3" class="db" d="M187.0866,2.4571v14.1732"/>
    <path id="bg" data-name="path12958-2-8-0-1" class="db" d="M189.9212,2.4571v14.1732"/>
    <path id="bh" data-name="path12958-2-8-4-9" class="db" d="M192.7559,2.4571v14.1732"/>
    <path id="bi" data-name="path12958-2-8-8-8" class="db" d="M195.5906,2.4571v14.1732"/>
    <path id="bj" data-name="path12958-2-8-0-2-0" class="db" d="M201.2598,2.4571v14.1732"/>
    <path id="bk" data-name="path12958-2-8-4-4-2" class="db" d="M204.0945,2.4571v14.1732"/>
    <path id="bl" data-name="path12958-2-8-4-4-5-8" class="db" d="M206.9291,2.4571v14.1732"/>
    <path id="bm" data-name="path12958-2-8-4-4-1-6" class="db" d="M209.7638,2.4571v14.1732"/>
    <path id="bn" data-name="path12958-2-8-7-86" class="db" d="M130.3937,2.4571v14.1732"/>
    <path id="bo" data-name="path12958-2-8-0-50" class="db" d="M133.2283,2.4571v14.1732"/>
    <path id="bp" data-name="path12958-2-8-4-90" class="db" d="M136.063,2.4571v14.1732"/>
    <path id="bq" data-name="path12958-2-8-8-0" class="db" d="M138.8976,2.4571v14.1732"/>
    <path id="br" data-name="path12958-2-8-0-2-38" class="db" d="M144.5669,2.4571v14.1732"/>
    <path id="bs" data-name="path12958-2-8-4-4-93" class="db" d="M147.4016,2.4571v14.1732"/>
    <path id="bt" data-name="path12958-2-8-4-4-5-4" class="db" d="M150.2362,2.4571v14.1732"/>
    <path id="bu" data-name="path12958-2-8-4-4-1-46" class="db" d="M153.0709,2.4571v14.1732"/>
    <path id="bv" data-name="path12958-2-8-7-18" class="db" d="M158.7402,2.4571v14.1732"/>
    <path id="bw" data-name="path12958-2-8-0-4" class="db" d="M161.5748,2.4571v14.1732"/>
    <path id="bx" data-name="path12958-2-8-4-96" class="db" d="M164.4095,2.4571v14.1732"/>
    <path id="by" data-name="path12958-2-8-8-3" class="db" d="M167.2441,2.4571v14.1732"/>
    <path id="bz" data-name="path12958-2-8-0-2-88" class="db" d="M172.9134,2.4571v14.1732"/>
    <path id="ca" data-name="path12958-2-8-4-4-29" class="db" d="M175.748,2.4571v14.1732"/>
    <path id="cb" data-name="path12958-2-8-4-4-5-1" class="db" d="M178.5827,2.4571v14.1732"/>
    <path id="cc" data-name="path12958-2-8-4-4-1-35" class="db" d="M181.4173,2.4571v14.1732"/>
    <path id="cd" data-name="path12958-2-8-7-0" class="db" d="M215.4331,2.4571v14.1732"/>
    <path id="ce" data-name="path12958-2-8-0-7" class="db" d="M218.2677,2.4571v14.1732"/>
    <path id="cf" data-name="path12958-2-8-4-6" class="db" d="M221.1024,2.4571v14.1732"/>
    <path id="cg" data-name="path12958-2-8-8-36" class="db" d="M223.937,2.4571v14.1732"/>
    <path id="ch" data-name="path12958-2-8-0-2-4" class="db" d="M229.6063,2.4571v14.1732"/>
    <path id="ci" data-name="path12958-2-8-4-4-20" class="db" d="M232.441,2.4571v14.1732"/>
    <path id="cj" data-name="path12958-2-8-4-4-5-9" class="db" d="M235.2756,2.4571v14.1732"/>
    <path id="ck" data-name="path12958-2-8-4-4-1-7" class="db" d="M238.1102,2.4571v14.1732"/>
    <path id="cl" data-name="path12958-2-8-7-6" class="db" d="M243.7795,2.4571v14.1732"/>
    <path id="cm" data-name="path12958-2-8-0-0" class="db" d="M246.6142,2.4571v14.1732"/>
    <path id="cn" data-name="path12958-2-8-4-1" class="db" d="M249.4488,2.4571v14.1732"/>
    <path id="co" data-name="path12958-2-8-8-6" class="db" d="M252.2835,2.4571v14.1732"/>
    <path id="cp" data-name="path12958-2-8-0-2-7" class="db" d="M257.9527,2.4571v14.1732"/>
    <path id="cq" data-name="path12958-2-8-4-4-54" class="db" d="M260.7874,2.4571v14.1732"/>
    <path id="cr" data-name="path12958-2-8-4-4-5-12" class="db" d="M263.6221,2.4571v14.1732"/>
    <path id="cs" data-name="path12958-2-8-4-4-1-0" class="db" d="M266.4567,2.4571v14.1732"/>
    <path id="ct" data-name="path12958-2-8-7-38" class="db" d="M272.126,2.4571v14.1732"/>
    <path id="cu" data-name="path12958-2-8-0-01" class="db" d="M274.9606,2.4571v14.1732"/>
    <path id="cv" data-name="path12958-2-8-4-25" class="db" d="M277.7953,2.4571v14.1732"/>
    <path id="cw" data-name="path12958-2-8-8-09" class="db" d="M280.6299,2.4571v14.1732"/>
    <path id="cx" data-name="path12958-2-8-0-2-78" class="db" d="M286.2992,2.4571v14.1732"/>
    <path id="cy" data-name="path12958-2-8-4-4-3" class="db" d="M289.1338,2.4571v14.1732"/>
    <path id="cz" data-name="path12958-2-8-4-4-5-5" class="db" d="M291.9685,2.4571v14.1732"/>
    <path id="da" data-name="path12958-2-8-4-4-1-1" class="db" d="M294.8032,2.4571v14.1732"/>
  </g>
</svg>`

const html = String.raw`
${MeasureSVG}
<dialog>	
	<input type="number" id="numeric" size="5" />
	<input type="range" min="0" max="100" step=".1" value="39.7" id="slider">	
	<button type="button" class="save">save</button>
	<button type="button" class="clear">clear</button>
</dialog>`

function getPixelPitch(diagonalScreenSize: number): number {
	const width = window.screen.width * devicePixelRatio
	const height = window.screen.height * devicePixelRatio
	const diagonalPixels = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2))
	const diagonalMM = diagonalScreenSize * 25.4
	return diagonalMM / diagonalPixels
}

function getScreenSize(pixelPitch: number) {
	const width = window.screen.width * pixelPitch
	const height = window.screen.height * pixelPitch
	const diagonalMM = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2))
	return diagonalMM / 25.4 * devicePixelRatio
}

function getKey() {
	return `PixelPitch:${screen.width}x${screen.height}x${window.devicePixelRatio}`
}

export function getSavedPixelPitch() {
	return parseFloat(localStorage.getItem(getKey())) || null
}

export default class RealWorldScale extends HTMLElement {
	dom: {
		ruler: SVGElement
		slider: HTMLInputElement
		numeric: HTMLInputElement
		saveButton: HTMLButtonElement
		clearButton: HTMLButtonElement
	}

	pixelPitch: number

	constructor() {
		super()
		this.attachShadow({ 'mode': 'open' })
	}

	connectedCallback() {
		this.shadowRoot.innerHTML = style + html
		this.dom = {
			ruler: this.shadowRoot.querySelector('svg'),
			slider: this.shadowRoot.getElementById('slider') as HTMLInputElement,
			numeric: this.shadowRoot.getElementById('numeric') as HTMLInputElement,
			saveButton: this.shadowRoot.querySelector('button.save'),
			clearButton: this.shadowRoot.querySelector('button.clear')
		}

		this.pixelPitch = parseFloat(localStorage.getItem(getKey())) || 0.2 / devicePixelRatio

		this.dom.slider.value = getScreenSize(this.pixelPitch).toString()

		this.dom.slider.addEventListener('input', () => {
			this.dom.numeric.value = parseFloat(this.dom.slider.value).toFixed(1)
			this.updateScale(parseFloat(this.dom.slider.value))
		})

		this.dom.numeric.addEventListener('input', () => {
			const value = parseFloat(this.dom.numeric.value)
			if (!isNaN(value) && value >= 3.5) {
				this.dom.slider.value = value.toString()
				this.updateScale(value)
			}
		})

		this.dom.ruler.addEventListener('click', () => {
			if (this.dom.ruler.classList.contains('icon')) {
				this.dom.ruler.classList.toggle('icon')
				this.updateScale(parseFloat(this.dom.slider.value))
			}
		})

		this.dom.saveButton.addEventListener('click', this.saveSettings.bind(this))
		this.dom.clearButton.addEventListener('click', this.clearSettings.bind(this))
		this.dom.slider.dispatchEvent(new Event('input'))
	}

	updateScale(screenSize: number) {
		console.log('updateScale', screenSize)
		this.pixelPitch = getPixelPitch(screenSize)
		const left = this.dom.slider.offsetLeft + (screenSize / 100 * this.dom.slider.clientWidth)
		this.dom.numeric.style.left = left + 'px'
		;(this.shadowRoot.host as HTMLElement).style.setProperty('--pixelPitch', (this.pixelPitch * devicePixelRatio).toString())
	}

	saveSettings() {
		localStorage.setItem(getKey(), this.pixelPitch.toString())
		this.dispatchEvent(new Event('change'))
		this.remove()
	}
	clearSettings() {
		Array.from(Array(localStorage.length)).map((x, i) => localStorage.key(i))
			.filter(x => x.startsWith('PixelPitch:'))
			.forEach(x => localStorage.removeItem(x))
		this.dispatchEvent(new Event('change'))
		this.remove()
	}
}
customElements.define('realtime-scale', RealWorldScale)
